import { render, staticRenderFns } from "./GstWithHoldingStatementDetail.vue?vue&type=template&id=4777b50e&scoped=true"
import script from "./GstWithHoldingStatementDetail.vue?vue&type=script&lang=js"
export * from "./GstWithHoldingStatementDetail.vue?vue&type=script&lang=js"
import style0 from "./GstWithHoldingStatementDetail.vue?vue&type=style&index=0&id=4777b50e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4777b50e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4777b50e')) {
      api.createRecord('4777b50e', component.options)
    } else {
      api.reload('4777b50e', component.options)
    }
    module.hot.accept("./GstWithHoldingStatementDetail.vue?vue&type=template&id=4777b50e&scoped=true", function () {
      api.rerender('4777b50e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gstreport/GstWithHoldingStatementDetail.vue"
export default component.exports